import { useResource, useEdgesFrom } from '@/db/hooks'
import type { TaskSpec, TaskStatus } from '@/kinds/task/schema'
import type { TaskResource } from '@/kinds/task/apply'
import { useUi } from '@/state/ui'
import { DeferMenu } from './DeferMenu'
import { ProjectPicker } from './ProjectPicker'

/** Sheets opened from the keyboard, rendered once in the shell. */
export const GlobalMenus = () => {
  const menu = useUi((s) => s.menu)
  const setMenu = useUi((s) => s.setMenu)
  const task = useResource<TaskSpec, TaskStatus>(menu?.taskId) as TaskResource | undefined
  const edges = useEdgesFrom(menu?.taskId)
  if (!menu || !task) return null
  const close = () => setMenu(null)
  if (menu.type === 'defer') return <DeferMenu task={task} open onClose={close} />
  const current = edges.find((e) => e.relation === 'belongs_to')?.to_id
  return <ProjectPicker task={task} open onClose={close} current={current} />
}
